import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
} from "@mui/material"
import { links } from "@oboku/shared"
import { lock } from "../common/locks/utils"
import { sendMessageToServiceWorker } from "./communication/communication.web"
import { skipWaitingMessage } from "./communication/types.shared"

export const UpdateAvailableDialog = ({
  serviceWorker,
}: {
  serviceWorker?: ServiceWorker
}) => {
  const hasUpdate = !!serviceWorker

  if (import.meta.env.MODE === "development") return null

  return (
    <Dialog open={hasUpdate}>
      <DialogTitle>A new version is here</DialogTitle>
      <DialogContent>
        <DialogContentText>
          A new version of the app is available. (
          <b>This action is mandatory right now until release</b>). See the full{" "}
          <Link href={`${links.github}/releases`} target="_blank">
            changelog here.
          </Link>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => {
            if (!serviceWorker) return

            lock()

            sendMessageToServiceWorker(serviceWorker, skipWaitingMessage())
          }}
          color="primary"
          autoFocus
        >
          Reload
        </Button>
      </DialogActions>
    </Dialog>
  )
}
